import {observer} from 'mobx-react-lite';
import {useTranslation} from 'react-i18next';
import {Col, Row} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileCsv} from '@fortawesome/free-solid-svg-icons';
import Button from '../shared/buttons/Button';

const BatchLogTableAction = ({disabled, onExport}) => {
  const {t} = useTranslation();

  const iconStyle = { marginRight: '5px' };

  return (
    <Row>
      <Col style={{width: '100%', textAlign: 'right'}}>
        <Button
          type={'link'}
          onClick={() => onExport()}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faFileCsv} style={iconStyle}/>
          {t('batchLog.actions.exportToCsv')}
        </Button>
        <Button
          type={'link'}
          onClick={() => onExport(true)}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faFileCsv} style={iconStyle}/>
          {t('batchLog.actions.exportToCsvWithConsumptions')}
        </Button>
      </Col>
    </Row>
  );
};

export default observer(BatchLogTableAction);
